import styled from 'styled-components';

const TableHeaderData = styled.div`
  width: max-content;
  max-width: 12rem;
  word-break: break-word;
`;

export default TableHeaderData;
